import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: 'Programs', path: '/programs' },
  { label: 'Impact', path: '/impact' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) =>
    path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#003366] shadow-lg' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-12 h-12 flex items-center justify-center rounded-full overflow-hidden bg-white">
              <img
                src="https://static.readdy.ai/image/cc883008a4d7bcfeafa6a2e5816cdde1/37b170ad110bf8756df40953dd95ddb8.jpeg"
                alt="El Hai Ministries Hands to serve, Hearts to care"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="hidden sm:block">
              <p className="text-white font-bold text-sm leading-tight font-poppins">EL HAI PENTECOSTAL</p>
              <p className="text-[#ADD8E6] text-xs font-medium tracking-wider">MINISTRIES</p>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 text-sm font-medium tracking-wide transition-all duration-200 rounded-md whitespace-nowrap ${
                  isActive(link.path)
                    ? 'text-[#ADD8E6] border-b-2 border-[#ADD8E6]'
                    : 'text-white hover:text-[#ADD8E6]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/donate"
              className="ml-4 px-5 py-2 bg-[#ADD8E6] text-[#003366] text-sm font-semibold rounded-md hover:bg-white transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Donate Now
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`} />
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="lg:hidden bg-[#003366] border-t border-[#ADD8E6]/30 py-4 px-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-3 text-sm font-medium rounded-md transition-colors cursor-pointer ${
                  isActive(link.path)
                    ? 'text-[#ADD8E6] bg-white/10'
                    : 'text-white hover:text-[#ADD8E6] hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/donate"
              className="block mt-3 mx-4 py-3 text-center bg-[#ADD8E6] text-[#003366] font-semibold rounded-md cursor-pointer"
            >
              Donate Now
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
}
